import { isChaosVariant, type GameConfig } from '../../shared/config';
import type { GameMode } from '../../shared/modes';

export const MODE_INFO: Record<GameMode, { title: string; rules: string }> = {
  daily: {
    title: 'Daily',
    rules: 'Everyone plays the same board today. You get one attempt. A new puzzle arrives at midnight.',
  },
  casual: {
    title: 'Classic',
    rules: 'Find as many words as you can before the clock runs out.',
  },
  competitive: {
    title: 'Competitive',
    rules:
      'Queue for a ranked 1v1: you and your opponent play the same 4×4 board for 90 seconds, and unique words score 1.5×. Win to climb the tiers; once you reach a tier, you keep it. When nobody is around, you play a labeled bot.',
  },
  endless: {
    title: 'Endless',
    rules: 'The board changes at a regular interval. Finish whenever you want.',
  },
  practice: {
    title: 'Practice',
    rules:
      'There’s no timer, and you can ask for a hint from the top bar whenever you’re stuck. Practice rounds aren’t ranked.',
  },
  versus: {
    title: 'Versus',
    rules:
      'Play the same board as your friends. In Live, everyone plays at once; in Turns, each player takes a timed turn and the next round opens once everyone has played. The host picks Classic or Chaos, the board, the timer and word lengths. Join mid-round and you’ll play in the next one.',
  },
};

/** The confirmation shown before a player finishes their participation early. */
export function finishConfirmation(mode: GameMode): string {
  if (mode === 'versus' || mode === 'competitive')
    return 'Finish your participation? Your accepted words will count. Other players can keep playing.';
  if (mode === 'daily')
    return 'Finish your Daily attempt? Your accepted words will count. You cannot retry this Daily attempt.';
  return 'Finish this round and view results? Your accepted words will count.';
}

/** The rule set a configuration plays under, for stats lines and history rows. */
export function rulesLabel(config: Pick<GameConfig, 'variant' | 'scoringMode'>): string {
  return isChaosVariant(config) ? 'chaos' : config.scoringMode;
}
